// extracted by mini-css-extract-plugin
module.exports = {"qaItemsHolder":"QAItemList_qaItemsHolder__363xz","qaItemsHolderAttendee":"QAItemList_qaItemsHolderAttendee__1DXY_"};